/* eslint-disable prettier/prettier */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import LogInContext from '../context/LogInContext'
import ContentfulButton from './Utilities/Buttons/ContentfulButton'
import NavLinkGroup from './Navigation/NavLinkGroup'
import TopBar from './Navigation/TopBar'
import ChevronDown from '../assets/images/icons/chevron-down.png'

import { reloadIfCurrentRoute } from '../helpers/pageUtils'

import '../sass/mainv3.scss'

class HeaderV3 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasScrolled: false,
      changeHeaderStyle: false,
      open: false,
      showCategories: false,
      categories: {},
      selectedCategory: 'Avant News'
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener(
      'click',
      e => !e.target.matches('.blog-category-button') && this.handleCloseShowCategories()
    )
    const { navigation, blogCategory } = this.props
    let blogCategoryNav = null
    if (navigation) blogCategoryNav = navigation.blogCategoryNavigation
    if (blogCategoryNav) {
      const blogCategories = {}
      blogCategoryNav.forEach(category => {
        const { title, url } = category
        if (!blogCategories[title]) {
          if (title === blogCategory) {
            blogCategories[title.toUpperCase()] = { selected: true, link: url }
          } else {
            blogCategories[title.toUpperCase()] = { selected: false, link: url }
          }
        }
      })
      this.setState({ selectedCategory: blogCategory.toUpperCase() })
      this.setState({ categories: blogCategories })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.addEventListener(
      'click',
      e => !e.target.matches('.blog-category-button') && this.handleCloseShowCategories()
    )
  }

  /* eslint-disable consistent-return */
  handleScroll = () => {
    if (this.props.dropInHeader?.current) {
      return window.pageYOffset > this.props.dropInHeader.current.offsetTop
        ? this.setState({ hasScrolled: true })
        : this.setState({ hasScrolled: false })
    }
  }

  toggleImage = () => this.setState({ open: !this.state.open })

  toggleShowCategories = () => this.setState({ showCategories: !this.state.showCategories })

  handleCloseShowCategories = () => this.setState({ showCategories: false })

  handleHeaderChange = () => this.setState({ changeHeaderStyle: !this.state.changeHeaderStyle })

  mobileMenuOnClick = () => {
    this.toggleImage()
    this.handleHeaderChange()
  }

  render() {
    const { hasScrolled, showCategories, categories, selectedCategory } = this.state
    const { heros, navigation } = this.props
    const noNavigation = navigation?.linkGroups === null
    let blogCategoryNav = null
    if (navigation) blogCategoryNav = navigation.blogCategoryNavigation

    let headerClasses = []
    headerClasses.push(this.state.hasScrolled ? 'header-wrap sticky ' : 'header-wrap')
    headerClasses = headerClasses.join(' ')

    let navItemsComp = []

    if (heros?.length && heros[0].navItems?.length) {
      const { navItems } = heros[0]
      navItems.map(item =>
        navItemsComp.push(
          /* eslint-disa  le react/no-array-index-key */
          <ContentfulButton data={item} key={item.id} />
        )
      )
      navItemsComp = <div className="nav-items">{navItemsComp}</div>
    }

    let blogNavDesktop = null
    let blogNavMobile = null
    if (blogCategoryNav) {
      blogNavDesktop = Object.keys(categories).map(category => {
        return (
          <Link
            to={`${categories[category].link}`}
            key={category}
            className={`blog-category-item ${categories[category].selected ? 'selected' : ''}`}
          >
            {category}
          </Link>
        )
      })
      blogNavMobile = (
        <div className="blog-category-dropdown">
          <button
            type="button"
            onClick={this.toggleShowCategories}
            className="blog-category-button"
          >
            {selectedCategory}
            <img
              src={ChevronDown}
              alt="A button to uncollapse hidden content"
              className="chevron-down"
            />
          </button>
          {showCategories && (
            <div className="blog-category-dropdown-menu">
              {blogCategoryNav.map(({ title, url }) => {
                return (
                  <div key={title} className="blog-category-dropdown-menu-item">
                    <a href={url} onClick={() => reloadIfCurrentRoute(`${url}`)}>
                      {title}
                    </a>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      )
    }

    return (
      <LogInContext.Consumer>
        {theme => (
          <>
            <header
              className={`${headerClasses} ${
                this.state.changeHeaderStyle ? 'change-header-style' : ''
              }`}
            >
              {navigation?.loginButton &&
                navigation.redeemOfferLinkGroup &&
                navigation.myAccount && (
                  <div className="top-bar-div show-desktop">
                    <div
                      className={
                        !noNavigation || (noNavigation && this.props.odsLogin)
                          ? 'container__top_bar'
                          : 'container__top_bar ods-nav'
                      }
                    >
                      <TopBar
                        theme={theme}
                        login={navigation.loginButton}
                        myAccount={navigation.myAccount}
                        linkGroups={navigation.redeemOfferLinkGroup}
                      />
                    </div>
                  </div>
                )}
              <div
                className={
                  !noNavigation || (noNavigation && this.props.odsLogin)
                    ? 'container__inner'
                    : 'container__inner ods-nav'
                }
              >
                <div className={hasScrolled ? 'header header--no-border' : 'header'}>
                  <div className="img-div">
                    {navigation?.logo && navigation.mobileLogo && (
                      <Link
                        to={navigation.logo.url}
                        className="header__home"
                        data-event="home"
                        onClick={() => reloadIfCurrentRoute('/')}
                      >
                        <picture className="header__logo">
                          <source
                            srcSet={navigation.logo.image.file.url}
                            media="(min-width: 70em)"
                          />
                          <img
                            src={
                              this.state.open
                                ? navigation.mobileLogo.image.file.url
                                : navigation.logo.image.file.url
                            }
                            alt="Avant Logo"
                            aria-label="Avant Logo"
                          />
                        </picture>
                      </Link>
                    )}
                  </div>
                  {navItemsComp}
                  {((noNavigation && this.props.odsLogin) || !noNavigation) && (
                    <div className="navigation">
                      <input
                        className="navigation__checkbox"
                        type="checkbox"
                        id="menu_toggle"
                        name="menu_toggle"
                        onClick={this.mobileMenuOnClick}
                      />

                      <label className="navigation__button" htmlFor="menu_toggle">
                        <span className="navigation__icon">
                          <span className="hide-display">Menu</span>
                        </span>
                      </label>

                      <nav className="navigation__menu">
                        {navigation?.loginButton &&
                          navigation.myAccount &&
                          navigation.redeemOfferLinkGroup && (
                            <div className="show-mobile">
                              <TopBar
                                theme={theme}
                                login={navigation.loginButton}
                                myAccount={navigation.myAccount}
                                linkGroups={navigation.redeemOfferLinkGroup}
                              />
                            </div>
                          )}

                        <ul className="navigation__list">
                          {!noNavigation && (
                            <>
                              {/* eslint-disable jsx-a11y/anchor-is-valid */}
                              {navigation?.linkGroups?.map(linkGroup => {
                                return (
                                  <NavLinkGroup
                                    linkGroups={linkGroup}
                                    key={JSON.stringify(linkGroup)}
                                    handleWindowReload={reloadIfCurrentRoute}
                                  />
                                )
                              })}
                            </>
                          )}
                        </ul>
                      </nav>
                    </div>
                  )}
                </div>
              </div>
            </header>
            {blogCategoryNav && (
              <div
                className={`blog-category-navigation ${this.state.hasScrolled ? 'sticky ' : ''}`}
              >
                <div className="container__inner">
                  <div className="blog-category-desktop">{blogNavDesktop}</div>
                  {blogNavMobile}
                </div>
              </div>
            )}
          </>
        )}
      </LogInContext.Consumer>
    )
  }
}

HeaderV3.defaultProps = {
  heros: null,
  odsLogin: false,
  blogCategory: ''
}

HeaderV3.propTypes = {
  heros: PropTypes.array,
  dropInHeader: PropTypes.object.isRequired,
  odsLogin: PropTypes.bool,
  navigation: PropTypes.object.isRequired,
  blogCategory: PropTypes.string
}

export default HeaderV3
